import React from 'react';
import PropTypes from 'prop-types';

function AddressBlock({
  title,
  contactName,
  companyName,
  addrLine1,
  addrLine2,
  city,
  state,
  zipCode,
  country,
  addressMissing,
  canEdit,
  handleOpenModal,
  type,
}) {
  return (
    <>
      <b>{title}</b>
      {canEdit
        ? (
          <button
            type="button"
            className="ml-1 btn btn-link"
            onClick={() => handleOpenModal(type)}
          >
            <u>edit</u>
          </button>
        )
        : null}
      {addressMissing ? (
        <>
          <br />
          {' '}
          No Address
          {' '}
        </>
      )
        : (
          <>
            <br />
            {contactName && (
            <>
              {contactName}
              <br />
            </>
            )}
            {companyName && (
            <>
              {companyName}
              <br />
            </>
            )}
            {addrLine1}
            {' '}
            {addrLine2}
            <br />
            {city}
            ,
            {' '}
            {state}
            {' '}
            {zipCode}
            <br />
            {country}
          </>
        )}
    </>
  );
}

AddressBlock.propTypes = {
  title: PropTypes.string,
  companyName: PropTypes.string,
  contactName: PropTypes.string,
  addrLine1: PropTypes.string,
  addrLine2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zipCode: PropTypes.string,
  country: PropTypes.string,
  addressMissing: PropTypes.bool,
  canEdit: PropTypes.bool,
  handleOpenModal: PropTypes.func,
  type: PropTypes.number.isRequired,
};

AddressBlock.defaultProps = {
  addressMissing: false,
  canEdit: false,
  handleOpenModal: () => {},
  title: '',
  companyName: '',
  contactName: '',
  addrLine1: '',
  addrLine2: '',
  city: '',
  state: '',
  zipCode: '',
  country: '',
};

export default AddressBlock;
